module.exports = __webpack_public_path__ + "f99c33c609936747d91a1a38c110e80f.svg";